import React from 'react';
import { PackageDetails } from '@/Hooks/PUJ/usePackageDetail';
import { Movie, Show } from '@skytvnz/sky-app-store/lib/types/graph-ql';
import useMedia from '@/Hooks/useMedia';
import getLabel from '@/Utils/LabelsConfig';
import { LABELS_CONFIG } from '@/Hooks/PUJ/constants';
import { PinValidationModalProps } from '@/Components/Modal/usePinValidationModal';
import { CustomerPackageOffer } from '@/lib/graph-ql';
import HeroButtons from './HeroButtons';
import styles from './styles.module.scss';

interface Props {
  brand: Show | Movie;
  isHome: boolean;
  hasPkgUpgrade: boolean;
  onMyListToggle?: any;
  origin?: string;
  packageDetails?: PackageDetails;
  openPinModal?: (_pkg: PinValidationModalProps) => void;
  offerDetails?: CustomerPackageOffer;
}
const DetailsHero: React.FC<Props> = ({
  brand,
  isHome,
  onMyListToggle,
  hasPkgUpgrade,
  packageDetails,
  origin,
  openPinModal,
}) => {
  const { hintMessage, isPackageDetailPage, discountPrice, offerId } = packageDetails || {};
  const { isMediaM } = useMedia();
  return (
    <div className={styles.heroContainer}>
      {hasPkgUpgrade && !isPackageDetailPage && offerId && (
        <div className={styles.hintContainer}>
          <>
            <span className={styles.hintText}>{hintMessage}</span>
          </>
        </div>
      )}
      {isPackageDetailPage && (
        <div className={styles.hintContainer}>
          <span className={styles.hintText}>{hintMessage}</span>
        </div>
      )}
      {hasPkgUpgrade && (
        <HeroButtons
          brand={brand}
          isHome={isHome}
          onMyListToggle={onMyListToggle}
          hasPkgUpgrade={hasPkgUpgrade}
          packageDetails={packageDetails}
          origin={origin}
          openPinModal={openPinModal}
        />
      )}
      {(isPackageDetailPage || hasPkgUpgrade) && isMediaM && offerId && (
        <div className={styles.hintContainerPUJ}>
          <span className={styles.pinHintText}> {getLabel(LABELS_CONFIG.ENTER_PIN_HINT)}</span>
        </div>
      )}
      {hasPkgUpgrade && discountPrice && (
        <div className={styles.hintContainerPUJ}>
          <span className={styles.pinHintText}>
            <a
              href="https://www.sky.co.nz/offer-terms"
              className={styles.underlineLink}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getLabel(LABELS_CONFIG.TERMS_CONDITION)}
            </a>{' '}
          </span>
        </div>
      )}
    </div>
  );
};

export default DetailsHero;
